import {
  Box,
  Typography,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
  Grid,
  Tooltip,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto'; // Automatically registers needed chart types
import { API_HOST } from '../../Services/baseUrl';

const getLast6Months = () => {
  const months = [];
  const now = new Date();
  for (let i = 5; i >= 0; i--) {
    const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
    months.push(date.toISOString().slice(0, 7)); // "YYYY-MM"
  }
  return months;
};

function MonthlyReportDashboard() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const months = getLast6Months();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${API_HOST}third-party-reports/companies-report-monthly`);
        setData(res.data.data || []);
      } catch (err) {
        console.error(err);
        setError('Failed to load report data.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <Box sx={{ textAlign: 'center', mt: 8 }}>
        <CircularProgress />
        <Typography variant="body2" sx={{ mt: 2 }}>
          Loading company monthly reports...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: 'center', mt: 8 }}>
        <Typography variant="h6" color="error">
          {error}
        </Typography>
      </Box>
    );
  }

  if (!data.length) {
    return (
      <Box sx={{ textAlign: 'center', mt: 8 }}>
        <Typography>No data found.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 1000, mx: 'auto', mt: 4, px: 2 }}>
      <Typography variant="h5" fontWeight={600} gutterBottom>
        Company Report Trends (Last 6 Months)
      </Typography>

      {data.map((company, idx) => {
        const chartData = {
          labels: months,
          datasets: [
            {
              label: 'Reports',
              data: months.map((month) => company.monthlyCounts[month] || 0),
              backgroundColor: '#1976d2',
              borderRadius: 4,
              barThickness: 28,
            },
          ],
        };

        return (
          <Accordion key={idx} sx={{ mb: 2 }} defaultExpanded={idx === 0}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography fontWeight={600}>{company.name}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Bar data={chartData} options={{
                responsive: true,
                plugins: {
                  legend: { display: false },
                  tooltip: { enabled: true },
                },
                scales: {
                  y: { beginAtZero: true, ticks: { precision: 0 } }
                }
              }} />
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Box>
  );
}

export default MonthlyReportDashboard;
